import React from 'react';
import { Img } from '../ContentTile/styles';

function ResponsiveImage({ alt, srcSet, height, width }) {
  const mapBreakpointsToSources = () =>
    Array.isArray(srcSet)
      ? srcSet.reduce((acc, item) => {
          acc[item.bp] = item.src;
          return acc;
        }, {})
      : {};

  const srcs = mapBreakpointsToSources(srcSet);
  return (
    <picture>
      {/* Portrait aspect ratio */}

      <source
        srcSet={`
          ${srcs.xs} 390w,
          ${srcs.sm} 770w,
          ${srcs.md} 1130w
        `}
        media="(max-width: 767px) and (orientation: portrait)"
        type="image/webp"
        sizes="100vw"
      />

      {/* Landscape aspect ratio */}
      <source
        srcSet={`
          ${srcs.xl || srcs.md} 1536w,
          ${srcs.xxl || srcs.md} 2208w
        `}
        media="(min-width: 768px) and (orientation: landscape)"
        type="image/webp"
        sizes="(min-width:1130px) 1130px, 100vw"
      />

      {/* Fallback image */}
      <Img
        style={{ objectFit: 'cover' }}
        src={`${srcs.xs}`}
        alt={alt}
        loading="lazy"
        width={width}
        height={height}
      />
    </picture>
  );
}

export default ResponsiveImage;
